/**
 * ページネーション設定一覧取得条件VO
 *
 * @export GetPageCopyModel
 * @class GetPageCopyModel
 */
export class GetPageCopyModel {
  // 媒体区分
  public MediumType = String('');
  // 使用開始 受注コード From
  public OrderCodeFrom = String('');
  // 使用開始 受注コード To
  public OrderCodeTo = String('');
}
